import { validate } from "../../helpers/validate.js";
import { EditorClasses } from "../../styles.js";
import {
  attributesFineprintSchema
} from "./attributes.js";
const scalarFineprint = {
  name: "scalar-fineprint",
  tagName: "scalar-fineprint",
  tiptapName: "scalar-fineprint",
  attributeTransform: () => {
    return validate(attributesFineprintSchema, {});
  },
  render: async () => {
    return `<cite class="${EditorClasses.FinePrint}"><ssg-children></ssg-children></cite>`;
  },
  markdownHandler: (state, node) => {
    const children = state.all(node);
    const openTag = "<scalar-fineprint>";
    const closeTag = "</scalar-fineprint>";
    if (!children.length) {
      return [{ type: "html", value: openTag + closeTag }];
    }
    return [
      { type: "html", value: openTag },
      ...children,
      { type: "html", value: closeTag }
    ];
  }
};
export {
  scalarFineprint
};
//# sourceMappingURL=index.js.map
